import { useQuery } from '@tanstack/react-query';

import { getHardwareDevice } from '@/pages/api/scribeAPI';
import type { HardwareDeviceResponse } from '@/types';
import { reactQueryClient } from '@/utils/reactQueryClient';

export const GET_HARDWARE_DEVICE = 'getHardwareDevice';

const getHardwareDeviceQueryOptions = (id: string) => ({
  queryKey: [GET_HARDWARE_DEVICE, { id }],
  queryFn: async () => {
    const { data } = await getHardwareDevice(id);
    return data;
  },
});

/** Mark cached device data as stale — triggers refetch if an observer is active. */
export const invalidateHardwareDevice = async (id: string) => {
  await reactQueryClient.invalidateQueries({
    queryKey: [GET_HARDWARE_DEVICE, { id }],
  });
};

export function useQueryHardwareDevice(id: string | null) {
  return useQuery<HardwareDeviceResponse>({
    ...getHardwareDeviceQueryOptions(id!),
    enabled: !!id,
  });
}
